var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metric-row"},_vm._l((_vm.capabilityList),function(cap,idx){return _c('capability-icon',{key:idx,attrs:{"count":_vm.capabilityList.length,"capability":cap,"value":_vm.metricValues[idx]}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }